import React from 'react'

interface FormStepperProps {
  steps: string[]
  currentStep: number
  canNavigateToStep: (step: number) => boolean
  onStepClick: (step: number) => void
}

export const FormStepper: React.FC<FormStepperProps> = ({
  steps,
  currentStep,
  canNavigateToStep,
  onStepClick,
}) => {
  return (
    <nav aria-label="Étapes du formulaire" className="mb-6">
      <ol className="flex items-center gap-2">
        {steps.map((label, index) => {
          const isActive = index === currentStep
          const isCompleted = index < currentStep
          const isClickable = canNavigateToStep(index) && !isActive
          const isLast = index === steps.length - 1

          return (
            <li key={label} className={`flex items-center gap-2 ${isLast ? '' : 'flex-1'}`}>
              <button
                type="button"
                onClick={() => isClickable && onStepClick(index)}
                disabled={!canNavigateToStep(index)}
                className={`flex items-center gap-2 min-w-0 text-left rounded-lg transition-colors ${
                  isClickable ? 'cursor-pointer hover:opacity-80' : 'cursor-default'
                } ${!canNavigateToStep(index) ? 'opacity-60' : ''}`}
                aria-current={isActive ? 'step' : undefined}
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                    isActive
                      ? 'bg-[var(--color-primary)] text-white'
                      : isCompleted || canNavigateToStep(index)
                        ? 'bg-[var(--color-primary)]/15 text-[var(--color-primary)]'
                        : 'bg-[var(--color-gray-100)] text-[var(--color-text-muted)]'
                  }`}
                >
                  {index + 1}
                </span>
                <span
                  className={`hidden sm:block text-sm font-medium truncate ${
                    isActive
                      ? 'text-[var(--color-text-primary)]'
                      : isCompleted || canNavigateToStep(index)
                        ? 'text-[var(--color-primary)]'
                        : 'text-[var(--color-text-muted)]'
                  }`}
                >
                  {label}
                </span>
              </button>
              {!isLast && (
                <div
                  className={`h-0.5 flex-1 min-w-4 rounded ${
                    isCompleted ? 'bg-[var(--color-primary)]' : 'bg-[var(--color-border)]'
                  }`}
                  aria-hidden
                />
              )}
            </li>
          )
        })}
      </ol>
      <p className="mt-3 text-sm text-[var(--color-text-secondary)] sm:hidden">
        Étape {currentStep + 1} sur {steps.length} — {steps[currentStep]}
      </p>
    </nav>
  )
}
